import { FechaFunctionsService } from '@/utils/functions.service';
import { formatPedidoFolio } from '@/utils/pedido-folio';
import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver'

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  private _workbook: Workbook

  constructor(
    public Func: FechaFunctionsService,) { }

  downloadInforme(data: any, nombreArchivo) {
    try {
      if (data == null) throw Error()

      this._workbook = new Workbook();
      this._workbook.creator = 'SimpleLaundry'

      const sheet = this._workbook.addWorksheet('Informe')

      sheet.getColumn('A').width = 14;
      sheet.getColumn('B').width = 12;
      sheet.getColumn('C').width = 40;
      sheet.getColumn('D').width = 40;
      sheet.getColumn('E').width = 14;
      sheet.getColumn('F').width = 14;
      sheet.getColumn('G').width = 10;
      sheet.getColumn('H').width = 10;
      sheet.getColumn('I').width = 10;
      sheet.getColumn('J').width = 30;
      sheet.getColumn('K').width = 14;

      const headerRow = sheet.getRow(1)
      headerRow.values = [
        'Fecha Ingreso',
        'Pedido',
        'Cliente',
        'Proceso',
        'Forma Pago',
        'Referencia',
        'Abono',
        'Saldo',
        'Total',
        'Observacion',
        'Estado',
      ]

      headerRow.font = { bold: true, size: 12 }

      const rowsToInsert = sheet.getRows(2, data.length);

      for (let index = 0; index < rowsToInsert.length; index++) {
        const itemData = data[index];
        const row = rowsToInsert[index];
        
        row.values = [
          this.Func.DateFormated(itemData.fecha_ingreso),
          formatPedidoFolio(itemData),
          itemData.cliente.nombre_completo,
          itemData.productos?.replace(/<br>/g, "\n") ?? "",
          itemData.formas_pago?.replace(/<br>/g, "\n") ?? "",
          itemData.referencia?.replace(/<br>/g, "\n") ?? "",
          (Number(itemData.total_venta) - Number(itemData.saldo)),
          Number(itemData.saldo),
          Number(itemData.total_venta),
          itemData.observacion,
          itemData.estado.nombre_estado
        ]
      }

      this._workbook.xlsx.writeBuffer()
        .then((data) => {
          const blob = new Blob([data])
          fs.saveAs(blob, nombreArchivo)
        })
    } catch (error) {
      throw error;
    }
  }

  downloadProductos(data: any, nombreArchivo = "ListadoProductos.xlsx") {
    try {
      if (data == null) throw Error()

      this._workbook = new Workbook();
      this._workbook.creator = 'SimpleLaundry'

      const sheet = this._workbook.addWorksheet('Productos')

      sheet.getColumn('A').width = 14;
      sheet.getColumn('B').width = 40;
      sheet.getColumn('C').width = 14;
      sheet.getColumn('D').width = 17;
      sheet.getColumn('E').width = 14;
      sheet.getColumn('F').width = 14;
      sheet.getColumn('G').width = 14;
      sheet.getColumn('H').width = 14;

      const headerRow = sheet.getRow(1)
      headerRow.values = [
        'Id Producto',
        'Nombre',
        'Valor',
        'Procesaimento',
        'Costo',
        'Usa Stock',
        'Stock',
        'Habilitado'
      ]

      headerRow.font = { bold: true, size: 12 }

      const rowsToInsert = sheet.getRows(2, data.length);

      for (let index = 0; index < rowsToInsert.length; index++) {
        const itemData = data[index];
        const row = rowsToInsert[index];

        row.values = [
          itemData.id_producto,
          itemData.nombre,
          itemData.valor,
          itemData.procesamiento,
          itemData.costo,
          itemData.useStock == 1 ? "Si" : "No",
          itemData.stock,
          itemData.habilitado == 1 ? "Si" : "No",
        ]
      }

      sheet.getColumn('A').eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "FF85c8ff"
          }
        }
      });

      this._workbook.xlsx.writeBuffer()
        .then((data) => {
          const blob = new Blob([data])
          fs.saveAs(blob, nombreArchivo)
        })
    } catch (error) {
      throw error;
    }
  }
  downloadInformeArqueo(data: any, nombreArchivo) {
    try {
      if (data == null) throw Error()

      this._workbook = new Workbook();
      this._workbook.creator = 'SimpleLaundry'

      const sheet = this._workbook.addWorksheet('Informe')

      sheet.getColumn('A').width = 14;
      sheet.getColumn('B').width = 14;
      sheet.getColumn('C').width = 14;
      sheet.getColumn('D').width = 14;
      sheet.getColumn('E').width = 14;
      sheet.getColumn('F').width = 10;
      sheet.getColumn('G').width = 10;
      sheet.getColumn('H').width = 30;

      const headerRow = sheet.getRow(1)
      headerRow.values = [
        'Movimiento',
        'Pedido',
        'Tipo de Pago',
        'Fecha de Movimiento',
        'Hora de Movimiento',
        'Ingreso',
        'Egreso',
        'Motivo Movimiento',
      ]

      headerRow.font = { bold: true, size: 12 }

      const rowsToInsert = sheet.getRows(2, data.length);

      for (let index = 0; index < rowsToInsert.length; index++) {
        const itemData = data[index];
        const row = rowsToInsert[index];

        row.values = [
          itemData.movimiento,
          itemData.numero_pedido_format
            || (itemData.numero_pedido != null && itemData.numero_pedido !== ""
              ? `SL${String(itemData.numero_pedido).padStart(8, '0')}`
              : (itemData.id_pedido != "" ? `SL${itemData.id_pedido.toString().padStart(8, '0')}` : "")),
          itemData.tipopago,
          this.Func.DateFormated(itemData.fecha_movimiento),
          itemData.hora_movimiento,
          Number(itemData.ingreso),
          Number(itemData.egreso),
          itemData.motivo
        ]
      }

      this._workbook.xlsx.writeBuffer()
        .then((data) => {
          const blob = new Blob([data])
          fs.saveAs(blob, nombreArchivo)
        })
    } catch (error) {
      throw error;
    }
  }
}
